import React, { useEffect } from "react";
import {
  createEmptyBottleSelectionRow,
  getSelectableBottleOptions,
  getUnusedBottleOptions,
  toBottleOptionLabel,
} from "../../utils/bottleServiceHelpers.js";
import "../../pages/BottleAvailabilityPage.css";

export default function BookingBottleSelection({
  alcoholicEntries,
  nonAlcoholicEntries,
  selectedAlcoholic,
  setSelectedAlcoholic,
  selectedNonAlcoholic,
  setSelectedNonAlcoholic,
  defaultReservationPrice = 0,
  selectedDate = "",
  disabled = false,
}) {
  useEffect(() => {
    setSelectedAlcoholic(alcoholicEntries.length ? [createEmptyBottleSelectionRow()] : []);
    setSelectedNonAlcoholic(nonAlcoholicEntries.length ? [createEmptyBottleSelectionRow()] : []);
  }, [alcoholicEntries, nonAlcoholicEntries, setSelectedAlcoholic, setSelectedNonAlcoholic]);

  const updateRow = (setter, rowIdx, patch) => {
    setter((prev) =>
      prev.map((row, idx) => (idx === rowIdx ? { ...row, ...patch } : row))
    );
  };

  const addRow = (setter, entries, rows) => {
    if (!getUnusedBottleOptions(entries, rows).length) return;
    setter((prev) => [...prev, createEmptyBottleSelectionRow()]);
  };

  const removeRow = (setter, rowIdx) => {
    setter((prev) => (prev.length <= 1 ? prev : prev.filter((_, idx) => idx !== rowIdx)));
  };

  const renderGroup = (title, entries, rows, setter, keyPrefix) => {
    if (!entries.length) return null;
    return (
      <div className="bottle-group-card booking-bottle-group">
        <h3 className="bottle-group-title">{title}</h3>
        {rows.map((row, idx) => {
          const options = getSelectableBottleOptions(entries, rows, idx);
          return (
            <div key={`${keyPrefix}-${idx}`} className="bottle-picker-row">
              <label className="bottle-picker-label">{`Bottle ${idx + 1}`}</label>
              <div className="bottle-picker-control-row">
                <select
                  className="bottle-select"
                  value={row.selectedId}
                  disabled={disabled}
                  onChange={(e) => updateRow(setter, idx, { selectedId: e.target.value })}
                >
                  <option value="">Select bottle</option>
                  {options.map((entry) => (
                    <option key={entry.id} value={entry.id}>
                      {toBottleOptionLabel(entry.item, selectedDate, defaultReservationPrice)}
                    </option>
                  ))}
                </select>
                {idx > 0 ? (
                  <button
                    type="button"
                    className="bottle-remove-btn"
                    disabled={disabled}
                    onClick={() => removeRow(setter, idx)}
                  >
                    Remove
                  </button>
                ) : null}
              </div>
            </div>
          );
        })}
        <button
          type="button"
          className="bottle-add-btn"
          disabled={disabled || !getUnusedBottleOptions(entries, rows).length}
          style={{ display: getUnusedBottleOptions(entries, rows).length ? undefined : "none" }}
          onClick={() => addRow(setter, entries, rows)}
        >
          {`Add another ${title.toLowerCase()} bottle`}
        </button>
      </div>
    );
  };

  return (
    <section className="booking-bottle-section">
      <h2 className="booking-bottle-title">Bottle Service</h2>
      {renderGroup("Alcoholic", alcoholicEntries, selectedAlcoholic, setSelectedAlcoholic, "alc")}
      {renderGroup("Non-Alcoholic", nonAlcoholicEntries, selectedNonAlcoholic, setSelectedNonAlcoholic, "non")}
    </section>
  );
}
